import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ShoeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
    <path
      fillRule="evenodd"
      d="M18 9c0-1.18-.56-2.32-1.4-3.08a3.56 3.56 0 0 0-3.36-.88 7.4 7.4 0 0 0-3.76 2.72A7.92 7.92 0 0 0 8.2 14.2a28.7 28.7 0 0 0 1.1 3.96c.44 1.2 1 2.38 1.67 3.05a3.95 3.95 0 0 0 3.03.97 3.9 3.9 0 0 0 3.01-1.63c.46-.7.44-1.47.31-2.1a10.9 10.9 0 0 0-.6-1.79v-.03a12 12 0 0 1-.57-1.64c-.12-.5-.12-.88-.02-1.17.15-.46.38-.87.67-1.37l.35-.63c.42-.75.85-1.69.85-2.82Zm-4.24-2.04c.52-.14 1.05.02 1.5.43.46.43.74 1.04.74 1.61 0 .62-.23 1.18-.6 1.86-.08.14-.16.3-.26.45-.31.55-.69 1.2-.91 1.87a4.14 4.14 0 0 0-.03 2.26c.15.66.42 1.32.64 1.88l.02.04c.24.61.42 1.09.5 1.5.08.4.02.53-.01.59-.28.41-.83.7-1.5.74-.68.05-1.23-.17-1.46-.4a7.3 7.3 0 0 1-1.21-2.32 25.48 25.48 0 0 1-1.02-3.67 5.92 5.92 0 0 1 .93-4.86 5.43 5.43 0 0 1 2.67-1.98Z"
      clipRule="evenodd"
    />
    <path d="M11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
  </Icon>
));
export default ShoeIcon;
